import { render, staticRenderFns } from "./TranDetail.vue?vue&type=template&id=928be09a&"
import script from "./TranDetail.vue?vue&type=script&lang=ts&"
export * from "./TranDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports